import { mmFetchWithResponse } from './mmFetchWithResponse';

const growthApi = {
    cancelCampaign: async (campaignID) => {
        const url = `api/email/v1/campaigns/${campaignID}/cancel`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    cancelRecurringCampaign: async (campaignID) => {
        const url = `api/email/v1/campaigns/recurring/${campaignID}/cancel`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
        });
    },
    updateEmailCampaignSegment: async (campaignID, segmentName, data) => {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key] || '');
        });

        const url = `api/email/v1/campaigns/${campaignID}/segments/${segmentName}`;

        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    createEmailCampaign: async (data) => {
        const formData = new FormData();

        const cleanedSegments = [];
        Object.keys(data).forEach((key) => {
            // stringify the segments for the formData
            const segmentKeys = ['segment1', 'segment2', 'segment3'];
            if (segmentKeys.includes(key)) {
                // extract files from the segments
                const segment = data[key];
                if (!segment || !segment.name) {
                    return { status: false, msg: 'Segment incomplete' };
                }

                const cleanedSegment = {};
                Object.keys(segment).forEach((key) => {
                    if (typeof segment[key] === 'object') {
                        console.log(`segment_${segment.name}_${key}`, segment[key]);
                        formData.set(`segment_${segment.name}_${key}`, segment[key]);
                    } else {
                        cleanedSegment[key] = segment[key];
                    }
                });
                cleanedSegments.push(cleanedSegment);
            } else {
                formData.set(key, data[key]);
            }
        });
        formData.set('segments', JSON.stringify(cleanedSegments));

        const url = `api/email/v1/campaigns`;

        return mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
    },
    getRecurringCampaigns: async () => {
        const url = 'api/email/v1/campaigns/recurring';
        return mmFetchWithResponse(url);
    },
    getCampaigns: async (recurringID = null) => {
        let url = 'api/email/v1/campaigns';
        if (recurringID) {
            url += `?recurringID=${recurringID}`;
        }
        return mmFetchWithResponse(url);
    },
    getNPSResults: async () => {
        const url = `api/growth/v1/nps`;
        return mmFetchWithResponse(url);
    },
    updateNPSResult: async (npsId, id, sendParams) => {
        const url = `api/growth/v1/nps/${npsId}/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(sendParams),
        });
    },
    sendTestEmail: async (email, campaignID, segment = '') => {
        let url = `api/email/v1/campaigns/${campaignID}/test?email=${email}`;
        if (segment) {
            url += `&segment=${segment}`;
        }
        return mmFetchWithResponse(url);
    },
    getOrderScheduledMerchandisedTemplateData: async (notifyServiceID) => {
        const url = `api/email/v1/campaigns/autopopulate?notifyServiceID=${notifyServiceID}`;
        return mmFetchWithResponse(url);
    },
    getNPSSentimentCategories: async (npsID) => {
        const url = `api/growth/v1/nps/${npsID}`;
        return mmFetchWithResponse(url);
    },
    getNPSCategories: async () => {
        const url = `api/growth/v1/nps/categories`;
        return mmFetchWithResponse(url);
    },
    createNPSSentCatCombo: async (npsID, data) => {
        const url = `api/growth/v1/nps/${npsID}`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(data),
        });
    },
    deleteSentCatCombo: async (id) => {
        const url = `api/growth/v1/nps/${id}`;
        return mmFetchWithResponse(url, {
            method: 'DELETE',
        });
    },
    createNPSCategory: async (category) => {
        const url = `api/growth/v1/nps/categories`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ category }),
        });
    },
};

export { growthApi };
